import script from "./SecurityPrivacy.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityPrivacy.vue?vue&type=script&setup=true&lang=js"

import "./SecurityPrivacy.vue?vue&type=style&index=0&id=22f106ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f106ca"]])

export default __exports__